const getUnlocalizedSpecificationItem = (serverSpecificationItems)=>{
    var ref;
    return (ref = serverSpecificationItems === null || serverSpecificationItems === void 0 ? void 0 : serverSpecificationItems.find((item)=>item.locale === 'en'
    )) === null || ref === void 0 ? void 0 : ref.value;
};

export { getUnlocalizedSpecificationItem };
//# sourceMappingURL=get-unlocalized-specification-item.js.map
